import styled, { css } from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

import CardOriginal from '../../../Card/Card';
import ButtonIcon from '../../../Icons/ButtonIcon';

export const Container = styled.div`
  position: relative;
`;

export const Card = styled(CardOriginal)`
  display: flex;
  flex-flow: wrap-reverse;
`;

export const RemovedOverlay = styled.div`
  z-index: 1;
  ${fontTitle(14)};
  color: var(--foreground);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--hover);
  opacity: 0.9;
  border-radius: inherit;
  text-align: center;

  ${breakpoint('medium')} {
    ${fontTitle(16)};
  }

  ${({ error }) =>
    error &&
    css`
      color: var(--destructive);
    `}
`;

export const Title = styled.h1`
  ${fontTitle(14)};
  color: var(--foreground);
  margin: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  ${fontBody(14)};
  color: var(--foreground);
  margin: 0;
`;

export const DeleteButton = styled(ButtonIcon).attrs({
  variant: 'defaultLight'
})`
  ${fontBody(16)};
`;
